import CSS from "./static/css/FolderEle.module.css";
import Text from "../../../../Component/Elements/Text/Text";
import DetailIcon from "../../../../Component/Elements/Icon/DetailIcon/DetailIcon";
import { forwardRef, useEffect, useState } from "react";
import FolderImageViewer from "../FolderImageViewer/FolderImageViewer";

interface folderElePropsInterface{
    foler_name: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    folder_img_src?: string;
    is_active?: boolean;
}

const FolderEle = forwardRef<HTMLDivElement, folderElePropsInterface>((
    {
        foler_name,
        onClick,
        folder_img_src,
        is_active,
    }, ref
) => {
    const [mainClassName, setMainClassName] = useState<string>(classNameSetter().join(" "));

    function classNameSetter(){
        const RTN: string[] = [];

        if(onClick){
            RTN.push("g_click_event_item");
        }

        RTN.push(CSS.l_FolderEle_main);

        if(is_active){
            RTN.push(CSS.active);
        }

        return RTN;
    }

    useEffect(() => {
        setMainClassName(classNameSetter().join(" "))
    }, [is_active, onClick])

    return(
        <div 
            className={mainClassName}
            onClick={onClick}
            ref={ref}
        >
            <Text bold={is_active}>
                {foler_name}
            </Text>


            {
                typeof folder_img_src === "string"
                &&  <div className={CSS.l_FolderEle__icon_container}>
                        <FolderImageViewer
                            img_src={folder_img_src}
                            btn_type={"icon"}
                        />
                    </div>
            }
        </div>
    )
})

export default FolderEle;